module.exports = __webpack_public_path__ + "static/media/maria1.bf0a27dc.mp3";